import * as Yup from 'yup'

export const validationSchema = Yup.object({
  formTab: Yup.string().required(),
  includeOwnMeasurements: Yup.boolean(),
  emissions: Yup.number().when('formTab', {
    is: 'carbon',
    then: Yup.number()
      .required('Please enter number of emissions')
      .min(1, 'Please enter more than 1tCO₂ equivalent emissions'),
    otherwise: Yup.number()
  }),
  stems: Yup.number().when('formTab', {
    is: 'stems',
    then: Yup.number()
      .required('Please enter number of stems planted')
      .min(1, 'Please enter more than 0 stems'),
    otherwise: Yup.number()
  }),
  age: Yup.number()
    .required('Please enter an age of stand in year')
    .min(1, 'Please enter an age greater than 1 year'),
  trees: Yup.number().min(0).max(100, 'Please enter less than 100% trees'),
  shrubs: Yup.number().min(0).max(100),
  standTreeAge: Yup.number().when('includeOwnMeasurements', {
    is: true,
    then: Yup.number().required('Please enter an age of stand when measured'),
    otherwise: Yup.number()
  }),
  standTreeSurvival: Yup.number()
    .min(0)
    .max(100, 'Please enter less than 100% survival'),
  standTreeHeight: Yup.number(),
  standTreeDBH: Yup.number(),
  standShrubSurvival: Yup.number()
    .min(0)
    .max(100, 'Please enter less than 100% survival'),
  standShrubHeight: Yup.number(),
  standShrubRCD: Yup.number()
})
